var exports = {
  "qd": "FloatingUnreadIndicators.module__layer___ZzdiU1",
  "NI": "FloatingUnreadIndicators.module__slot___ZzdiU1",
  "AH": "FloatingUnreadIndicators.module__slotTop___ZzdiU1",
  "Y0": "FloatingUnreadIndicators.module__slotBottom___ZzdiU1",
  "q3": "FloatingUnreadIndicators.module__indicator___ZzdiU1",
  "lL": "FloatingUnreadIndicators.module__indicatorBrand___ZzdiU1",
  "Gi": "FloatingUnreadIndicators.module__indicatorMention___ZzdiU1",
};

module.exports = exports;
